import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Card, CardHeader } from "@material-ui/core";
import { Container, Loading } from "src/components";
import {
  Equalizer as DashBoardIcon,
  SupervisedUserCircle as ClientesIcon,
  Map as MapIcon,
} from "@material-ui/icons";

import { useNavigate } from "react-router-dom";

import {
  carregaLocalizacao,
  listarClientesMapa,
} from "src/store/actions/fidelidade_mapa";

import "leaflet/dist/leaflet.css";
import "react-leaflet-fullscreen-control";
import L from "leaflet";

import {
  MapContainer,
  TileLayer,
  Marker,
  Tooltip as TooltipMap,
} from "react-leaflet";

import marker from "../../assets/images/map-pin.png";

const customMarker = new L.icon({
  iconUrl: marker,
  iconSize: [20, 28],
  iconAnchor: [5, 17],
  popupAnchor: [2, -40],
});

function FidelidadeMapa(props) {
  const { width } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { clientes, localizacao_empresa, loading } = useSelector(
    (state) => state.fidelidade_mapa
  );

  useEffect(() => dispatch([carregaLocalizacao(), listarClientesMapa()]), []);

  return (
    <Container
      title="Mapa de clientes"
      buttonsRight={[
        {
          title: "Dashboard",
          icon: <DashBoardIcon />,
          onClick: () => navigate("/app/dashboard/"),
          // disabled: true,
        },
        {
          title: "Mapa",
          icon: <MapIcon />,
          onClick: () => navigate("/app/dashboard/mapa"),
          disabled: true,
        },
        {
          title: "Resumo",
          icon: <ClientesIcon />,
          onClick: () => navigate("/app/dashboard/resumo"),
          // disabled: false,
        },
      ]}
    >
      <Loading loading={loading} />
      {localizacao_empresa.latitude && (
        <Card>
          <MapContainer
            style={{
              height: "calc(100vh - 200px)",
              width: "100%",
              borderRadius: 0,
            }}
            scrollWheelZoom={false}
            fullscreenControl
            zoom={14}
            center={[
              localizacao_empresa.latitude,
              localizacao_empresa.longitude,
            ]}
          >
            <TileLayer url="http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {clientes
              .filter(
                (item) => item.latitude !== null && item.longitude !== null
              )
              .map((item, k) => (
                <Marker
                  key={k}
                  position={[item.latitude, item.longitude]}
                  icon={customMarker}
                />
              ))}
          </MapContainer>
        </Card>
      )}
    </Container>
  );
}

export default FidelidadeMapa;
